import clsx from "clsx";
import styled from "styled-components";

import { ButtonLink, ClickableProps } from "~/components/Button";
import { Text } from "~/components/Text";
import * as Bulma from "~/types/bulma";

// TODO: https://bulma.io/documentation/components/breadcrumb/#alternative-separators

export type Props = Bulma.Sized & Bulma.Alignment;

/**
 * @example
 * import * as Breadcrumbs from "~/components/Breadcrumbs";
 * <Breadcrumbs.Container>
 *   <Breadcrumbs.Content>
 *     <Breadcrumbs.Item>
 *       <Breadcrumbs.ItemContent>
 *         <Breadcrumbs.ItemContentIcon>
 *           <ArrowLeftIcon />
 *         </Breadcrumbs.ItemContentIcon>
 *         <Breadcrumbs.ItemContentText>Back</Breadcrumbs.ItemContentText>
 *       </Breadcrumbs.ItemContent>
 *     </Breadcrumbs.Item>
 *   </Breadcrumbs.Content>
 * </Breadcrumbs.Container>
 */
export const Container = styled.nav.attrs<Props>((props) => ({
  className: clsx({
    [`breadcrumb`]: true,
    [`is-${props.sized}`]: Boolean(props.sized),
    [`is-${props.align}`]: Boolean(props.align),
  }),
  "aria-label": "breadcrumbs",
}))<Props>``;

export const Content = styled.ul``;
export const Item = styled.li.attrs<Bulma.Activable>((props) => ({
  className: clsx({
    [`is-active`]: props.active,
  }),
}))<Bulma.Activable>``;

export const ItemContent = styled(ButtonLink as "a").attrs<ClickableProps>({ as: "a" })<ClickableProps>``;
export const ItemContentText = styled(Text)``;
export const ItemContentIcon = styled.span.attrs({
  className: clsx({
    [`icon`]: true,
  }),
})``;
